import React from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'

function OpcionesConfiguracionDestare () {
  return (
    <>
      <Field
        className='campos-configuracion-destare'
        name='urlDestare'
        type='text'
        label='URL de lectura de peso destare'
        component={renderTextField}
        placeholder='http://localhost:12000'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMaximo'
        type='text'
        label='Peso máximo en destare'
        component={renderTextField}
        placeholder='55555'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMaximoAdvertencia'
        type='text'
        label='Peso máximo de advertencia en destare'
        component={renderTextField}
        placeholder='55555'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMinimo'
        type='text'
        label='Peso mínimo en destare'
        component={renderTextField}
        placeholder='55555'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMinimoAdvertencia'
        type='text'
        label='Peso mínimo de advertencia en destare'
        component={renderTextField}
        placeholder='55555'
      />
    </>
  )
}

export default OpcionesConfiguracionDestare
